module.exports = __webpack_public_path__ + "media/images/Welcome-rafiki-b32e2b213d8164bfc620486ca21161dc.png";